import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/Promoter Strength Prediction',
    name: 'PromoterStrengthPrediction',
    component: () => import('@/views/home-81/81-index.vue'),
    meta: {
      title: 'Promoter Strength Prediction'
    }
  },
  {
    path: '/De novo Promoter Generation',
    name: 'DeNovoPromoterGeneration',
    component: () => import('@/views/home-80/80-index.vue'),
    meta: {
      title: 'De novo Promoter Generation'
    }
  },
  // 默认路由，重定向到主页
  {
    path: '/',
    redirect: '/Promoter Strength Prediction'
  },
  // 捕获所有其他未匹配路径的路由
  {
    path: '*',
    redirect: '/Promoter Strength Prediction'
  }
]

const createRouter = () =>
  new Router({
    mode: 'history', // 使用 history 模式
    base: '/', // 设置基础路径为根路径
    scrollBehavior: () => ({ y: 0 }), // 页面滚动行为，默认滚动到顶部
    routes: constantRoutes // 路由配置
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重置路由
}

export default router
